module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.activate_token) ? _c('div', {
    staticStyle: {
      "margin": "4em",
      "text-align": "center"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]) : _vm._e()]) : _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#aa076b",
      "margin-top": "5em"
    },
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container banner-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col login-row",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "border-radius": "2px",
      "min-height": "500px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12 login-forms",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.reset_password) ? _c('div', {
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    attrs: {
      "id": "forgot"
    }
  }, [_c('h3', {
    staticClass: "gw-heading",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Reset your Password")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password1",
      "type": "password",
      "title": "Enter password",
      "placeholder": "New Password"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.new_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirm_password),
      expression: "user.confirm_password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password2",
      "type": "password",
      "title": "Enter password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.user.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirm_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.showPassword
    }
  }), _vm._v("Show Password\r\n                              ")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetForgotPassword
    }
  }, [_vm._v("Reset Password")])])])])])]) : _c('div', {}, [(_vm.set_forgot_password) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "forgot"
    }
  }, [_c('h4', {
    staticClass: "gw-heading",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Forgot Password ?")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("reset your password")]), _vm._v(" "), (_vm.set_cta) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]) : _vm._e(), _vm._v(" "), (!_vm.set_cta) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Please provide your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "8px",
      "color": "#aa076b"
    }
  }, [_vm._v("Have you remembered your Password? "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("Login Here")])])]) : _vm._e(), _vm._v(" "), (_vm.set_cta) ? _c('div', {
    staticClass: "cta_balloon"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("but first check your mail")])]) : _vm._e()]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('h2', {
    staticClass: "gw-heading"
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Log into your account")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "offset-sm-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-password",
      "type": "password",
      "name": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn gw-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login Now")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#aa076b"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('forgot', '')
      }
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#aa076b"
    },
    attrs: {
      "href": "/go/pricing"
    }
  }, [_vm._v("Register?")])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12 login-words gw-not-mobile",
    staticStyle: {
      "float": "left",
      "padding-top": "3em"
    }
  }, [_c('h4', [_vm._v("Gallery is specially designed for you")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Showcase your awesome designs")]), _vm._v(" "), _c('p', [_vm._v("Make your work roll out like a gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Continue viewing Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('p', [_vm._v("Gallery is specially designed for you")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7608d7de"}!./src/pages/Login/template.html
// module id = 268
// module chunks = 0